export enum ChatPathsEnum {
  ROOT = "chat",
}

export enum ChatRoutesEnum {
  ROOT = "/chat",
}
